<template>
  <section class="section-header">
    <dep-header
      :breadcrumb="breadcrumb"
      :title="title"
      :tabs="tabs"
      ref="sectionHeader"
      v-if="showHeader"
      v-on:breadcrumb-clicked="onBreadcrumbClicked"
    >
      <template slot="header-content">
        <slot name="header-content" />
      </template>
    </dep-header>

    <div class="section-header-content">
      <slot />
    </div>
  </section>
</template>

<script>
import DepHeader from "./DepHeader.vue";

export default {
  name: "header-section",
  components: { DepHeader },
  props: {
    breadcrumb: { type: Array, default: () => [] },
    title: { type: String },
    tabs: { type: Array, default: () => [] },
    onBreadcrumbClicked: {
      type: Function,
      default: () => {
        //TODO: Show error
      },
    },
    showHeader: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss">
.section-header {
  height: 100%;
  display: flex;
  flex-direction: column;

  &-content {
    flex-grow: 2;
    overflow-y: auto;

    & > section {
      height: 100%;
    }
  }
}
</style>
